import get from 'lodash/get'

import {
  SET_USER_SETTINGS,
  CHANGE_USER_DATA,
  CLEAR_TOKEN,
  LOG_OUT,
  NEW_SETTINGS_COLLECTION_DATA,
  NEW_SETTINGS_INTEGRATIONS_DATA,
  NEW_SETTINGS_PAYMENT_DATA,
  NEW_SETTINGS_PROFILE_DATA,
  NEW_SETTINGS_PROFILE_DATA_MANUAL,
  NEW_USER_DATA,
  OTP_TOKEN,
  REFRESH_TOKEN,
  RESET_ACCOUNT,
  SET_NEW_TOKEN,
  SET_NEW_USER_TOKEN,
  SET_TOKEN,
  TOGGLE_LOCALHOST,
  TOGGLE_KNOW_USER,
  NEW_SUBSCRIPTION_DATA,
  NEW_SUBSCRIPTION_PAYMENT,
  NEW_SUBSCRIPTION_TRANSACTIONS,
  NEW_SUBSCRIPTION_COUPON,
  NEW_TEAM_STATS,
  NEW_TEAM_ADD,
  NEW_PAYMENT_METHOD,
  NEW_PACKAGE_DATA,
  USERS_LIST,
  COMPANIES_LIST,
  SET_NEW_COMPANY,
  SET_URL_REPORT_COMPANY,
  SET_NAME_DELETE_COMPANY,
  MOBILE_ALERT,
  VERIFY_ACCOUNT_ACTION,
  USER_PHONE,
  OTP_UUID,
  OTP_VERIFIED,
  STEPPER_STEP,
  SET_USER_ROLE
} from '../actions/accountActions';

// Default account data
import accountProfile from '../resources/account_profile';


const initialState = {
  // Settings
  collection                    : null,
  integrations                  : null,
  payment                       : null,
  profile                       : accountProfile,
  team                          : null,
  teams                         : [],
  team_segmentation             : null,
  subscription                  : null,
  subscription_payment          : {},
  coupon                        : {},
  transactions                  : [],
  stats                         : null,
  paymentMethod                 : null,
  packageData                   : null,
  users_list                    : [],
  companies                     : [],
  name_company_delete           : null,
  url_reports                   : undefined,
  otpSession                    : {},
  otpVerified                   : null,
  step                          : null,
  
  // Session
  access_token : null,
  user_token   : null,
  email        : null,
  hasLoggedIn  : false,
  permissions  : null,
  phone        : null,
  user         : null,
  uuid         : null,
  verified     : null,
  otp_uuid     : null,
  time_zone    : new Date().getTimezoneOffset(),

  // Mobile Alert
  alertDisplayed: false,

  // App
  localhost     : null,
  user_settings : null,
  new_company   : null,

} // END initialState

export default function (state = initialState, action) {
  let { payload, type } = action, newState;
  switch (type) {
    case NEW_TEAM_ADD:
      newState = { teams: {...state.teams, ...payload }}
      return { ...state, ...newState }

    case USERS_LIST:
      newState = { users_list: payload }
      return { ...state, ...newState }

    case NEW_TEAM_STATS:
      newState = { stats: payload }
      return { ...state, ...newState }

    // Settings
    case NEW_SETTINGS_PROFILE_DATA:
      newState = { profile: payload }
      return { ...state, ...newState }

    case NEW_SETTINGS_PROFILE_DATA_MANUAL:
      newState = { profile: { ...state.profile, ...payload }}
      return { ...state, ...newState }

    case NEW_SETTINGS_PAYMENT_DATA:
      newState = { payment: payload }
      return { ...state, ...newState }

    case NEW_SETTINGS_COLLECTION_DATA:
      newState = { collection: payload }
      return { ...state, ...newState }

    case NEW_SETTINGS_INTEGRATIONS_DATA:
      newState = { integrations: payload }
      return { ...state, ...newState }

    // Session
    case SET_TOKEN:
    case REFRESH_TOKEN:
    case SET_NEW_TOKEN:
      newState = { access_token: validToken(payload) }
      return {...state, ...newState }
      // return { ...state, token: validToken(payload) || null }

    case NEW_PAYMENT_METHOD:
      newState = { paymentMethod: payload }
      return { ...state, ...newState }

    case NEW_PACKAGE_DATA:
      newState = { packageData: payload }
      return { ...state, ...newState }

    case NEW_SUBSCRIPTION_DATA:
      newState = { subscription: payload[0] }
      return { ...state, ...newState }

    case NEW_SUBSCRIPTION_COUPON:
      newState = { coupon: payload }
      return { ...state, ...newState }

    case NEW_SUBSCRIPTION_PAYMENT:
      newState = { subscription_payment: payload }
      return { ...state, ...newState }

    case NEW_SUBSCRIPTION_TRANSACTIONS:
      newState = { transactions: payload }
      return { ...state, ...newState }

    case NEW_USER_DATA:
      const { account, access_token } = payload;
      newState = { access_token, ...account }
      return { ...state, ...newState }

    case OTP_TOKEN:
      newState = { otpSession: payload }
      return { ...state, ...newState }

    case OTP_VERIFIED:
      newState = { otpVerified: payload }
      return { ...state, ...newState }

    case CHANGE_USER_DATA:
      newState = { access_token: payload }
      return { ...state, ...payload }

    case TOGGLE_KNOW_USER:
      newState = { hasLoggedIn: !state.hasLoggedIn }
      return { ...state, ...newState }

    case CLEAR_TOKEN:
      newState = { access_token: null }
      return { ...state, ...newState }

    case RESET_ACCOUNT:
      newState = { ...initialState }
      Object.assign(newState, { access_token: get(state, 'access_token') });
      delete newState.hasLoggedIn;
      delete newState.localhost;
      delete newState.access_token;
      return { ...state, ...newState }

    case LOG_OUT:
      newState = { ...initialState }
      delete newState.localhost;
      return { ...state, ...newState }

    case VERIFY_ACCOUNT_ACTION:
      return { ...state, verified: true };

    // APP
    case TOGGLE_LOCALHOST:
      const value = (state.localhost === null) ? true : !state.localhost;
      return { ...state, localhost: value }

    //MOBILE ALERT
    case MOBILE_ALERT:
      newState = { alertDisplayed: payload };
      return { ...state, ...newState };

    case SET_USER_SETTINGS:
      newState = { user_settings: payload };
      return { ...state, ...newState };

    case COMPANIES_LIST:
      newState = { companies: payload };
      return { ...state, ...newState };

    case SET_NEW_USER_TOKEN:
      newState = { user_token: payload };
      return { ...state, ...newState };

    case SET_NEW_COMPANY:
      newState = { new_company: payload };
      return { ...state, ...newState };

    case SET_NAME_DELETE_COMPANY:
      newState = { name_company_delete: payload };
      return { ...state, ...newState };

    case SET_URL_REPORT_COMPANY:
      newState = { url_reports: payload };
      return { ...state, ...newState };

    case USER_PHONE:
      newState = { phone: payload };
      return { ...state, ...newState };

    case OTP_UUID:
      newState = { otp_uuid: payload };
      return { ...state, ...newState };

    case STEPPER_STEP:
      newState = { step: payload };
      return { ...state, ...newState };

    case SET_USER_ROLE:
      newState = { rol_id: payload };
      return { ...state, ...newState };

    default:
      return state;

  } // END switch

} // END reducer

function validToken(token){
  if   (token) return token
  else           return null;

} // END validToken



// WEBPACK FOOTER //
// ./src/redux/reducers/accountReducer.js